/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as PublicUnauthorizedRouteImport } from './routes/_public/unauthorized'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthenticatedOntologyRouteImport } from './routes/_authenticated/ontology'
import { Route as AuthenticatedAgentRouteImport } from './routes/_authenticated/agent'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedIntegrationsIndexRouteImport } from './routes/_authenticated/integrations/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedBriefingsIndexRouteImport } from './routes/_authenticated/briefings/index'
import { Route as AuthenticatedAgentIndexRouteImport } from './routes/_authenticated/agent/index'
import { Route as PublicSlackInstallRouteImport } from './routes/_public/slack/install'
import { Route as AuthenticatedDashboardSlugRouteImport } from './routes/_authenticated/dashboard/$slug'
import { Route as AuthenticatedBriefingsInstructionsRouteImport } from './routes/_authenticated/briefings/instructions'
import { Route as AuthenticatedBriefingsSlugRouteImport } from './routes/_authenticated/briefings/$slug'
import { Route as AuthenticatedAgentThreadIdRouteImport } from './routes/_authenticated/agent/$threadId'
import { Route as AuthenticatedBriefingsDocumentsIdRouteImport } from './routes/_authenticated/briefings/documents/$id'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicUnauthorizedRoute = PublicUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedOntologyRoute = AuthenticatedOntologyRouteImport.update({
  id: '/ontology',
  path: '/ontology',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAgentRoute = AuthenticatedAgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsIndexRoute =
  AuthenticatedIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBriefingsIndexRoute =
  AuthenticatedBriefingsIndexRouteImport.update({
    id: '/briefings/',
    path: '/briefings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentIndexRoute = AuthenticatedAgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAgentRoute,
} as any)
const PublicSlackInstallRoute = PublicSlackInstallRouteImport.update({
  id: '/slack/install',
  path: '/slack/install',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedDashboardSlugRoute =
  AuthenticatedDashboardSlugRouteImport.update({
    id: '/dashboard/$slug',
    path: '/dashboard/$slug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBriefingsInstructionsRoute =
  AuthenticatedBriefingsInstructionsRouteImport.update({
    id: '/briefings/instructions',
    path: '/briefings/instructions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBriefingsSlugRoute =
  AuthenticatedBriefingsSlugRouteImport.update({
    id: '/briefings/$slug',
    path: '/briefings/$slug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentThreadIdRoute =
  AuthenticatedAgentThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => AuthenticatedAgentRoute,
  } as any)
const AuthenticatedBriefingsDocumentsIdRoute =
  AuthenticatedBriefingsDocumentsIdRouteImport.update({
    id: '/briefings/documents/$id',
    path: '/briefings/documents/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/agent': typeof AuthenticatedAgentRouteWithChildren
  '/ontology': typeof AuthenticatedOntologyRoute
  '/login': typeof PublicLoginRoute
  '/signup': typeof PublicSignupRoute
  '/unauthorized': typeof PublicUnauthorizedRoute
  '/agent/$threadId': typeof AuthenticatedAgentThreadIdRoute
  '/briefings/$slug': typeof AuthenticatedBriefingsSlugRoute
  '/briefings/instructions': typeof AuthenticatedBriefingsInstructionsRoute
  '/dashboard/$slug': typeof AuthenticatedDashboardSlugRoute
  '/slack/install': typeof PublicSlackInstallRoute
  '/agent/': typeof AuthenticatedAgentIndexRoute
  '/briefings/': typeof AuthenticatedBriefingsIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/briefings/documents/$id': typeof AuthenticatedBriefingsDocumentsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/ontology': typeof AuthenticatedOntologyRoute
  '/login': typeof PublicLoginRoute
  '/signup': typeof PublicSignupRoute
  '/unauthorized': typeof PublicUnauthorizedRoute
  '/agent/$threadId': typeof AuthenticatedAgentThreadIdRoute
  '/briefings/$slug': typeof AuthenticatedBriefingsSlugRoute
  '/briefings/instructions': typeof AuthenticatedBriefingsInstructionsRoute
  '/dashboard/$slug': typeof AuthenticatedDashboardSlugRoute
  '/slack/install': typeof PublicSlackInstallRoute
  '/agent': typeof AuthenticatedAgentIndexRoute
  '/briefings': typeof AuthenticatedBriefingsIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/briefings/documents/$id': typeof AuthenticatedBriefingsDocumentsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/agent': typeof AuthenticatedAgentRouteWithChildren
  '/_authenticated/ontology': typeof AuthenticatedOntologyRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_public/unauthorized': typeof PublicUnauthorizedRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/agent/$threadId': typeof AuthenticatedAgentThreadIdRoute
  '/_authenticated/briefings/$slug': typeof AuthenticatedBriefingsSlugRoute
  '/_authenticated/briefings/instructions': typeof AuthenticatedBriefingsInstructionsRoute
  '/_authenticated/dashboard/$slug': typeof AuthenticatedDashboardSlugRoute
  '/_public/slack/install': typeof PublicSlackInstallRoute
  '/_authenticated/agent/': typeof AuthenticatedAgentIndexRoute
  '/_authenticated/briefings/': typeof AuthenticatedBriefingsIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/briefings/documents/$id': typeof AuthenticatedBriefingsDocumentsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agent'
    | '/ontology'
    | '/login'
    | '/signup'
    | '/unauthorized'
    | '/agent/$threadId'
    | '/briefings/$slug'
    | '/briefings/instructions'
    | '/dashboard/$slug'
    | '/slack/install'
    | '/agent/'
    | '/briefings/'
    | '/dashboard/'
    | '/integrations/'
    | '/settings/'
    | '/briefings/documents/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ontology'
    | '/login'
    | '/signup'
    | '/unauthorized'
    | '/agent/$threadId'
    | '/briefings/$slug'
    | '/briefings/instructions'
    | '/dashboard/$slug'
    | '/slack/install'
    | '/agent'
    | '/briefings'
    | '/dashboard'
    | '/integrations'
    | '/settings'
    | '/briefings/documents/$id'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/agent'
    | '/_authenticated/ontology'
    | '/_public/login'
    | '/_public/signup'
    | '/_public/unauthorized'
    | '/_authenticated/'
    | '/_authenticated/agent/$threadId'
    | '/_authenticated/briefings/$slug'
    | '/_authenticated/briefings/instructions'
    | '/_authenticated/dashboard/$slug'
    | '/_public/slack/install'
    | '/_authenticated/agent/'
    | '/_authenticated/briefings/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/integrations/'
    | '/_authenticated/settings/'
    | '/_authenticated/briefings/documents/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/unauthorized': {
      id: '/_public/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof PublicUnauthorizedRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/ontology': {
      id: '/_authenticated/ontology'
      path: '/ontology'
      fullPath: '/ontology'
      preLoaderRoute: typeof AuthenticatedOntologyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent': {
      id: '/_authenticated/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AuthenticatedAgentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations/': {
      id: '/_authenticated/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthenticatedIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/briefings/': {
      id: '/_authenticated/briefings/'
      path: '/briefings'
      fullPath: '/briefings/'
      preLoaderRoute: typeof AuthenticatedBriefingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent/': {
      id: '/_authenticated/agent/'
      path: '/'
      fullPath: '/agent/'
      preLoaderRoute: typeof AuthenticatedAgentIndexRouteImport
      parentRoute: typeof AuthenticatedAgentRoute
    }
    '/_public/slack/install': {
      id: '/_public/slack/install'
      path: '/slack/install'
      fullPath: '/slack/install'
      preLoaderRoute: typeof PublicSlackInstallRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/dashboard/$slug': {
      id: '/_authenticated/dashboard/$slug'
      path: '/dashboard/$slug'
      fullPath: '/dashboard/$slug'
      preLoaderRoute: typeof AuthenticatedDashboardSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/briefings/instructions': {
      id: '/_authenticated/briefings/instructions'
      path: '/briefings/instructions'
      fullPath: '/briefings/instructions'
      preLoaderRoute: typeof AuthenticatedBriefingsInstructionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/briefings/$slug': {
      id: '/_authenticated/briefings/$slug'
      path: '/briefings/$slug'
      fullPath: '/briefings/$slug'
      preLoaderRoute: typeof AuthenticatedBriefingsSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent/$threadId': {
      id: '/_authenticated/agent/$threadId'
      path: '/$threadId'
      fullPath: '/agent/$threadId'
      preLoaderRoute: typeof AuthenticatedAgentThreadIdRouteImport
      parentRoute: typeof AuthenticatedAgentRoute
    }
    '/_authenticated/briefings/documents/$id': {
      id: '/_authenticated/briefings/documents/$id'
      path: '/briefings/documents/$id'
      fullPath: '/briefings/documents/$id'
      preLoaderRoute: typeof AuthenticatedBriefingsDocumentsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedAgentRouteChildren {
  AuthenticatedAgentThreadIdRoute: typeof AuthenticatedAgentThreadIdRoute
  AuthenticatedAgentIndexRoute: typeof AuthenticatedAgentIndexRoute
}

const AuthenticatedAgentRouteChildren: AuthenticatedAgentRouteChildren = {
  AuthenticatedAgentThreadIdRoute: AuthenticatedAgentThreadIdRoute,
  AuthenticatedAgentIndexRoute: AuthenticatedAgentIndexRoute,
}

const AuthenticatedAgentRouteWithChildren =
  AuthenticatedAgentRoute._addFileChildren(AuthenticatedAgentRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAgentRoute: typeof AuthenticatedAgentRouteWithChildren
  AuthenticatedOntologyRoute: typeof AuthenticatedOntologyRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBriefingsSlugRoute: typeof AuthenticatedBriefingsSlugRoute
  AuthenticatedBriefingsInstructionsRoute: typeof AuthenticatedBriefingsInstructionsRoute
  AuthenticatedDashboardSlugRoute: typeof AuthenticatedDashboardSlugRoute
  AuthenticatedBriefingsIndexRoute: typeof AuthenticatedBriefingsIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedIntegrationsIndexRoute: typeof AuthenticatedIntegrationsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedBriefingsDocumentsIdRoute: typeof AuthenticatedBriefingsDocumentsIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAgentRoute: AuthenticatedAgentRouteWithChildren,
  AuthenticatedOntologyRoute: AuthenticatedOntologyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBriefingsSlugRoute: AuthenticatedBriefingsSlugRoute,
  AuthenticatedBriefingsInstructionsRoute:
    AuthenticatedBriefingsInstructionsRoute,
  AuthenticatedDashboardSlugRoute: AuthenticatedDashboardSlugRoute,
  AuthenticatedBriefingsIndexRoute: AuthenticatedBriefingsIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedIntegrationsIndexRoute: AuthenticatedIntegrationsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedBriefingsDocumentsIdRoute:
    AuthenticatedBriefingsDocumentsIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicUnauthorizedRoute: typeof PublicUnauthorizedRoute
  PublicSlackInstallRoute: typeof PublicSlackInstallRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicUnauthorizedRoute: PublicUnauthorizedRoute,
  PublicSlackInstallRoute: PublicSlackInstallRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
